import {
  HomeState,
  INITIALISE,
  SET_PAGE,
  SET_CATEGORY,
  SET_CATEGORIES,
  SET_AUTHOR,
  SET_AUTHORS,
  SET_SEARCH,
  SET_ARTICLES,
  SET_LOADING,
  SET_PRIORITY_MODULES,
  HomeActionTypes,
} from './Types';

const initialState: HomeState = {
  survey: undefined,
  recentArticles: {
    page: 1,
    pageCount: 1,
    itemCount: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    items: [],
  },
  categories: [],
  categoryUses: {},
  currentCategory: 'All',
  currentAuthor: -1,
  currentSearch: '',
  currentPage: 1,
  authorName: '',
  authors: {},
  articles: {
    page: 1,
    pageCount: 1,
    itemCount: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    items: [],
  },
  priorityModules: [],
  loading: false,
};

export const homeReducer = (state = initialState, action: HomeActionTypes): HomeState => {
  switch (action.type) {
  case INITIALISE:
    return {
      ...state,
      ...action.payload,
      recentArticles: action.payload.articles,
    };
  case SET_PAGE:
    return {
      ...state,
      currentPage: action.payload,
    };
  case SET_CATEGORY:
    return {
      ...state,
      currentCategory: action.payload,
    };
  case SET_CATEGORIES:
    return {
      ...state,
      categories: action.payload,
    };
  case SET_AUTHOR:
    return {
      ...state,
      currentAuthor: action.payload.id,
      authorName: action.payload.name,
    };
  case SET_AUTHORS:
    return {
      ...state,
      authors: action.payload,
    };
  case SET_SEARCH:
    return {
      ...state,
      currentSearch: action.payload,
    };
  case SET_ARTICLES:
    return {
      ...state,
      articles: action.payload,
    };
  case SET_LOADING:
    return {
      ...state,
      loading: action.payload,
    };
  case SET_PRIORITY_MODULES:
    return {
      ...state,
      priorityModules: action.payload,
    };
  default:
    return state;
  }
};
